export enum PaymentIntegrator {
  CloverPaystream = 1,
  Bambora = 2,
  CloverPaystreamCardNotPresent = 3,
}
